import CooperPreuvesVirement from '../components/documents/CooperPreuvesVirement';
import React from 'react';
import AssistantIAUsageCard from '../components/AssistantIAUsageCard';
import DOMIUMAssistantDevis from '../components/DOMIUMAssistantDevis';
import RegistreMaitresOuvrage from '../components/RegistreMaitresOuvrage';
import { Button } from '../components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card';
import { UserPlus, Calculator, Home, FileText, DollarSign, TrendingUp, Users, User, FilePlus, RefreshCw } from 'lucide-react';
import { toast } from 'sonner';
import SouscriptionsValidation from '../components/SouscriptionsValidation';
import SouscriptionsListe from '../components/SouscriptionsListe';
import RCDSSouscriptionsDashboard from '../components/RCDSSouscriptionsDashboard';
import DOSDomiumDashboard from '../components/DOSDomiumDashboard';
import CooperStatsDashboard from '../components/CooperStatsDashboard';
import GestionDocuments from '../components/GED/GestionDocuments';
import VideoManager from '../components/GED/VideoManager';
import ZipSharesDashboard from '../components/GED/ZipSharesDashboard';
import MessagerieDashboard from '../components/Messagerie/MessagerieDashboard';
import CooperProfileEdit from '../components/ProfileEdit/CooperProfileEdit';
import MesConventions from '../components/MesConventions';
import CooperMembresManagement from '../components/CooperMembresManagement';
import GEDESS from '../components/GED/GEDESS';
import GEDDomium from '../components/GED/GEDDomium';
import GEDUniverselle from '../components/GED/GEDUniverselle';
import CoopersWalletDashboard from '../components/CoopersWalletDashboard';
import MesServicesLegalcoop from '../components/MesServicesLegalcoop';
import MesContratsCcmi from '../components/MesContratsCcmi';
import FTPESubscriptionForMember from '../components/FTPESubscriptionForMember';
import KPIDashboard from '../components/KPIDashboard';
import MonUsageCreditsWidget from '../components/MonUsageCreditsWidget';
import CooperLeaderboard from '../components/CooperLeaderboard';
import DOMIUMSubscriptionSimulator from '../components/DOMIUMSubscriptionSimulator';
import PropositionsSigneesWidget from '../components/PropositionsSigneesWidget';
import SuiviSignatures from '../components/admin/SuiviSignatures';
import PropositionsActivityChart from '../components/PropositionsActivityChart';

export default function CooperDashboardTabs({ activeTab, user, getAuthHeader, demandes, navigate, cooperData, setCooperData, fetchData }) {
  return (
    <>
      {activeTab === 'wallet-credits' && (
        <CoopersWalletDashboard />
      )}

      {activeTab === 'ftpe-membres' && (
        <Card className="border-l-4 border-l-amber-500">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-amber-700">
              <UserPlus className="h-6 w-6 text-amber-500" />
              Souscription FTPE pour vos Membres
            </CardTitle>
            <CardDescription>
              Inscrivez vos membres adhérents à la FTPE Outremer
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="bg-gradient-to-r from-amber-500 to-orange-500 rounded-xl p-6 text-white mb-6">
              <h3 className="text-xl font-bold mb-2">🏢 Adhésion FTPE Outremer</h3>
              <p className="text-amber-100 mb-4">
                En tant que COOPER'S, vous pouvez inscrire vos membres à la Fédération des TPE Outremer pour leur donner accès aux avantages exclusifs.
              </p>
              <FTPESubscriptionForMember onSuccess={() => {
                toast.success('Adhésion FTPE créée avec succès pour le membre');
                fetchData();
              }} />
            </div>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
              <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
                <div className="text-2xl mb-2">👥</div>
                <p className="text-sm font-medium text-amber-800">Représentation patronale</p>
              </div>
              <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
                <div className="text-2xl mb-2">🛡️</div>
                <p className="text-sm font-medium text-amber-800">Accès aux garanties</p>
              </div>
              <div className="p-4 bg-amber-50 rounded-lg border border-amber-200">
                <div className="text-2xl mb-2">🤝</div>
                <p className="text-sm font-medium text-amber-800">Réseau solidaire</p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {activeTab === 'simulateur' && (
        <Card className="border-l-4 border-l-coppam-gold">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-coppam-blue">
              <Calculator className="h-6 w-6 text-coppam-gold" />
              Simulateur Garantie Solidaire BATICO
            </CardTitle>
            <CardDescription>
              Proposez des simulations Garantie RCDS BATICO à vos membres adhérents
            </CardDescription>
          </CardHeader>
          <CardContent>
            <div className="bg-gradient-to-r from-purple-700 to-indigo-700 rounded-xl p-6 text-white">
              <h3 className="text-xl font-bold mb-2">🧮 Outil de simulation professionnel</h3>
              <p className="text-purple-100 mb-4">
                Calculez les cotisations Garantie RCDS BATICO pour vos membres et accompagnez-les dans leur souscription.
              </p>
              <div className="flex flex-wrap gap-3">
                <a href="/calculateur-batico" target="_blank" rel="noopener noreferrer">
                  <Button className="bg-coppam-gold hover:bg-yellow-500 text-slate-900 font-semibold">
                    <Calculator className="h-4 w-4 mr-2" />
                    Nouvelle Souscription
                  </Button>
                </a>
                <a href="/calculateur-batico?mode=avenant" target="_blank" rel="noopener noreferrer">
                  <Button className="bg-white hover:bg-gray-100 text-purple-700 font-semibold">
                    <FilePlus className="h-4 w-4 mr-2" />
                    Créer un Avenant
                  </Button>
                </a>
              </div>
            </div>
            <div className="mt-4 grid grid-cols-1 md:grid-cols-4 gap-4 text-center">
              <div className="p-4 bg-slate-50 rounded-lg">
                <div className="text-2xl mb-2">👥</div>
                <p className="text-sm text-slate-600">Pour vos membres</p>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg">
                <div className="text-2xl mb-2">📊</div>
                <p className="text-sm text-slate-600">Tarifs compétitifs</p>
              </div>
              <div className="p-4 bg-slate-50 rounded-lg">
                <div className="text-2xl mb-2">✅</div>
                <p className="text-sm text-slate-600">Validation simplifiée</p>
              </div>
              <div className="p-4 bg-purple-50 rounded-lg border border-purple-200">
                <div className="text-2xl mb-2">📝</div>
                <p className="text-sm text-purple-700 font-medium">Avenants</p>
              </div>
            </div>
          </CardContent>
        </Card>
      )}

      {activeTab === 'simulateur-dos' && (
        <Card className="border-l-4 border-l-orange-500">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-coppam-blue">
              <Home className="h-6 w-6 text-orange-500" />
              Simulateur DOS-DOMIUM
            </CardTitle>
            <CardDescription>
              Dommages-Ouvrage Solidaire - Simulez et gérez les souscriptions pour vos membres
            </CardDescription>
          </CardHeader>
          <CardContent>
            <DOMIUMSubscriptionSimulator userRole="cooper" />
          </CardContent>
        </Card>
      )}

      {activeTab === 'kpi-dashboard' && (
        <div className="space-y-4">
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
            <div className="lg:col-span-2">
              <KPIDashboard userRole="cooper" />
            </div>
            <div className="space-y-4">
              <MonUsageCreditsWidget getAuthHeader={getAuthHeader} />
              <CooperLeaderboard getAuthHeader={getAuthHeader} currentUserId={user?.id} />
              <MesContratsCcmi />
              <MesServicesLegalcoop />
            </div>
          </div>
        </div>
      )}

      {activeTab === 'statistiques' && (
        <CooperStatsDashboard />
      )}

      {activeTab === 'membres' && (
        <CooperMembresManagement />
      )}

      {activeTab === 'souscriptions-validation' && (
        <SouscriptionsValidation />
      )}

      {activeTab === 'preuves-virement' && <CooperPreuvesVirement />}

      {activeTab === 'souscriptions-liste' && (
        <SouscriptionsListe />
      )}

      {activeTab === 'suivi-signatures' && <SuiviSignatures />}
      {activeTab === 'propositions-signees' && (
        <div className="space-y-6">
          <PropositionsActivityChart />
          <PropositionsSigneesWidget />
        </div>
      )}

      {activeTab === 'suivi-rcds' && (
        <RCDSSouscriptionsDashboard getAuthHeader={getAuthHeader} userRole="cooper" />
      )}

      {activeTab === 'suivi-dos-domium' && (
        <DOSDomiumDashboard getAuthHeader={getAuthHeader} userRole="cooper" />
      )}

      {activeTab === 'registre-maitres-ouvrage' && <RegistreMaitresOuvrage />}

      {activeTab === 'assistant-ia-devis' && (
        <div className="space-y-4" data-testid="cooper-assistant-ia-devis">
          <AssistantIAUsageCard />
          <DOMIUMAssistantDevis />
        </div>
      )}

      {activeTab === 'adhesions' && (
        <div className="space-y-6">
          {/* Informations rapides */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <Card className="border-l-4 border-l-blue-500">
              <CardContent className="pt-6">
                <div className="flex items-start gap-3">
                  <div className="p-3 bg-blue-100 rounded-lg">
                    <FileText className="h-6 w-6 text-blue-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg text-slate-900 mb-1">Adhésions Actives</h3>
                    <p className="text-sm text-slate-600 mb-3">
                      Nombre total d'adhésions en cours
                    </p>
                    <p className="text-3xl font-bold text-blue-600">
                      {demandes.filter(d => d.statut === 'actif').length}
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>

            <Card className="border-l-4 border-l-green-500">
              <CardContent className="pt-6">
                <div className="flex items-start gap-3">
                  <div className="p-3 bg-green-100 rounded-lg">
                    <DollarSign className="h-6 w-6 text-green-600" />
                  </div>
                  <div>
                    <h3 className="font-bold text-lg text-slate-900 mb-1">Revenus Mensuels</h3>
                    <p className="text-sm text-slate-600 mb-3">
                      Estimé sur base des adhésions
                    </p>
                    <p className="text-3xl font-bold text-green-600">
                      {(demandes.length * 12).toFixed(2)}€
                    </p>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>

          {/* Accès à la gestion complète */}
          <Card>
            <CardHeader className="bg-gradient-to-r from-blue-500 to-cyan-500 text-white">
              <CardTitle className="flex items-center gap-2">
                <FileText className="h-5 w-5" />
                Gestion des Adhésions
              </CardTitle>
              <CardDescription className="text-white/90">
                Gérez les souscriptions de vos membres adhérents aux dispositifs solidaires
              </CardDescription>
            </CardHeader>
            <CardContent className="pt-6">
              <div className="text-center py-4 md:py-8">
                <div className="h-20 w-20 mx-auto mb-4 rounded-full bg-blue-100 flex items-center justify-center">
                  <FileText className="h-10 w-10 text-blue-600" />
                </div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Interface Complète</h3>
                <p className="text-slate-600 mb-6 max-w-md mx-auto">
                  Accédez à la page complète de gestion des adhésions pour créer, modifier et suivre toutes les souscriptions
                </p>
                <Button
                  onClick={() => navigate('/coopers/adhesions')}
                  size="lg"
                  className="bg-blue-600 hover:bg-blue-700"
                >
                  <FileText className="h-5 w-5 mr-2" />
                  Ouvrir la Gestion des Adhésions
                </Button>
              </div>

              {/* Fonctionnalités disponibles */}
              <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="p-4 bg-slate-50 rounded-lg text-center">
                  <Users className="h-6 w-6 mx-auto mb-2 text-slate-600" />
                  <div className="font-semibold text-sm">Gestion Membres</div>
                  <div className="text-xs text-slate-500 mt-1">Créer et suivre</div>
                </div>
                <div className="p-4 bg-slate-50 rounded-lg text-center">
                  <FileText className="h-6 w-6 mx-auto mb-2 text-slate-600" />
                  <div className="font-semibold text-sm">Documents</div>
                  <div className="text-xs text-slate-500 mt-1">Générer et télécharger</div>
                </div>
                <div className="p-4 bg-slate-50 rounded-lg text-center">
                  <TrendingUp className="h-6 w-6 mx-auto mb-2 text-slate-600" />
                  <div className="font-semibold text-sm">Statistiques</div>
                  <div className="text-xs text-slate-500 mt-1">Suivre l'activité</div>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      )}

      {/* Onglet Documents */}
      {activeTab === 'documents' && (
        <GestionDocuments />
      )}

      {/* Onglet GED Universelle */}
      {activeTab === 'ged-universelle' && (
        <GEDUniverselle />
      )}

      {/* Onglet GED ESS */}
      {activeTab === 'ged-ess' && (
        <div className="space-y-6">
          <GEDESS userRole="cooper" />
          <GEDDomium />
        </div>
      )}

      {/* Onglet Photos/Vidéos */}
      {activeTab === 'videos' && (
        <VideoManager userRole="cooper" showUpload={true} showDelete={true} />
      )}

      {/* Onglet Partages reçus */}
      {activeTab === 'partages-recus' && (
        <ZipSharesDashboard mode="received" />
      )}

      {/* Onglet Messagerie */}
      {activeTab === 'messagerie' && (
        <MessagerieDashboard />
      )}

      {/* Onglet Mes Conventions */}
      {activeTab === 'conventions' && (
        <MesConventions userType="cooper" />
      )}

      {/* Onglet Mon Profil */}
      {activeTab === 'profil' && (
        <div>
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Mon Profil COOPER'S</h2>
          {cooperData ? (
            <CooperProfileEdit
              cooper={cooperData}
              onUpdate={(updated) => setCooperData(updated)}
              getAuthHeader={getAuthHeader}
            />
          ) : (
            <Card>
              <CardContent className="pt-6">
                <div className="text-center py-8">
                  <User className="h-12 w-12 mx-auto mb-4 text-gray-400" />
                  <p className="text-gray-600 mb-4">Chargement du profil en cours...</p>
                  <Button onClick={fetchData} variant="outline">
                    <RefreshCw className="h-4 w-4 mr-2" />
                    Actualiser
                  </Button>
                </div>
              </CardContent>
            </Card>
          )}
        </div>
      )}
    </>
  );
}
